/**
 * Pet Mindful · Pestañas
 *
 * Patrón tablist de la APG: flechas para moverse, Home/End para los extremos.
 * Se usa en «Rutinas favoritas» y queda disponible para cualquier sección que
 * necesite pestañas, sin volver a escribir el teclado.
 */
class PMTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
    });

    this.syncTabindex();
  }

  panelFor(tab) {
    const id = tab.getAttribute('aria-controls');
    return id ? this.querySelector('#' + CSS.escape(id)) : null;
  }

  select(tab) {
    this.tabs.forEach((other) => {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      const panel = this.panelFor(other);
      if (panel) panel.hidden = !selected;
    });
    this.syncTabindex();
  }

  // Un solo tab en el orden de tabulación: las flechas mueven entre pestañas
  syncTabindex() {
    this.tabs.forEach((tab) => {
      tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
    });
  }

  onKeydown(event, tab) {
    const index = this.tabs.indexOf(tab);
    let next = null;

    switch (event.key) {
      case 'ArrowRight':
        next = this.tabs[(index + 1) % this.tabs.length];
        break;
      case 'ArrowLeft':
        next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        break;
      case 'Home':
        next = this.tabs[0];
        break;
      case 'End':
        next = this.tabs[this.tabs.length - 1];
        break;
      default:
        return;
    }

    event.preventDefault();
    this.select(next);
    next.focus();
  }
}

if (!customElements.get('pm-tabs')) {
  customElements.define('pm-tabs', PMTabs);
}
